import { render, staticRenderFns } from "./processRegister.vue?vue&type=template&id=adfdc420"
import script from "./processRegister.vue?vue&type=script&lang=js"
export * from "./processRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports